<template>
  <div>
    <div class="merchantdrop-container">
      <h2 class="merchantdrop-title">{{ $t('merchantDropoffFail.title') }}</h2>

      <div>
        <section class="merchantdrop-state">
          <div style="font-size:24px; margin-bottom: 10px">
            <h3>
              {{ $t('merchantDropoffFail.orderLabel') }}
              <strong style="font-weight:700">{{ barcodeId }}</strong>
            </h3>
            <br />
            <h3 style="margin-top: 10px;" v-if="reason === 'unknown'">
              {{ $t('merchantDropoffFail.somethingWentWrong') }}
            </h3>
            <br />
            <h3 style="margin-top: 10px;">
              {{ $t('merchantDropoffFail.requestFailed') }}
            </h3>
            <h3 style="margin-top: 10px;" v-if="reason">
              {{ reason }}
            </h3>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MerchantDropoffFail',
  components: {},
  props: {
    barcodeId: {
      type: String,
      required: true,
    },
    reason: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.merchantdrop-container {
  display: flex;
  flex-direction: column;
  max-width: 90%;
  margin: 0 auto;
  color: black;
  margin-top: 20px;
  line-height: 20px;
  flex: 1;
  display: flex;
}

.merchantdrop-title {
  font-family: 'Proxima Nova';
  font-size: 2rem;
  font-weight: 500;
  line-height: 100%;
  color: black;
}

.merchantdrop-header,
.merchantdrop-state {
  width: 100%;
  margin: 0 auto;
  background-color: rgba(
    255,
    0,
    0,
    0.6
  ); /* Add a semi-transparent background for better readability */
  border: 1px solid black;
  padding: 20px; /* Adjust padding as needed */
  border-radius: 10px; /* Optional: add border-radius for rounded corners */
  color: white;
}
@media (max-width: 768px) {
  .merchantdrop-container {
    padding-top: 0px;
    max-width: 100%;
  }

  .merchantdrop-header,
  .merchantdrop-state {
    padding: 10px;
  }
}
</style>
